import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const LineSeparator = styled.hr`
    border: 0;
    border-top: 1px solid #eee;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
`;

export const FilterComponentSelector = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    &:hover {
        cursor: pointer;
    }
`;

export const FilterComponentLabels = styled.label`
    display: flex;
    padding-left: ${(props) =>
        props.leftPadding ? props.leftPadding : '28px'};
    min-width: 0;
    padding-right: 17px;
    font-family: AvenirNextWorld Demi;
    width: 100%;
    font-size: 14px;
    align-items: center;
    &:hover {
        cursor: pointer;
    }
    ${media.smalDevice`
		width: ${(props) =>
            props.labelResponsiveWidth ? props.labelResponsiveWidth : '100%'};
		max-width: none;
    `}
`;

export const FilterLabel = styled.div`
    display: flex;
    text-align: left;
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Regular'};
    letter-spacing: -0.12px;
    color: ${(props) => (props.fontColor ? props.fontColor : '#000000')};
    margin-top: 0px;
    margin-bottom: 0px;
    width: ${(props) => (props.width ? props.width : '85%')};
    align-items: center;
    font-size: ${(props) => (props.fontSize ? props.fontSize : '15px')};
    word-break: break-word !important;
    word-break: break-all;
    ${media.smalDevice`
        width: ${(props) => (props.labelWidth ? props.labelWidth : '85%')};
    `}
    ${media.mobileDevice`
        width: ${(props) => (props.labelMbWidth ? props.labelMbWidth : '90%')};
    `}
`;

export const OrderStatusIcons = styled.img`
    width: 24px;
    height: 24px;
    margin-right: 15px;
    &:hover {
        cursor: pointer;
    }
`;
export const CheckBox = styled.img`
    margin-right: ${(props) =>
       props.rightMargin ? props.rightMargin : '25px'};
`;
export const FilterCheckbox = styled.input`
    margin: 0 !important;
    display: none;
`;

export const DefaultIndicator = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: 10px;
    color: #e5047e;
    border: 1px solid #e5047e;
    border-radius: 4px;
    width: ${({ width }) => (width ? width : '47px')};
    height: 18px;
    display: flex;
    justify-content: center;
    padding: 0 5px;
    margin-left: 20px;
    opacity: 1;
`;
